import apiClient from './api';
import type { DeviceFavorite } from '@/types';

/**
 * Personal device stars.
 *
 * Note what is missing: none of these take a user. The subject comes from the
 * token on every call, which is the whole of the privacy model — with no way to
 * name another user there is no way to read or change their favorites, and no
 * role is an exception.
 */
export const deviceFavoriteService = {
  list: () => apiClient.get<DeviceFavorite[]>('/admin/device-favorites'),

  /** Idempotent — starring an already-starred machine succeeds. */
  add: (machineId: string) =>
    apiClient.put<void>(`/admin/device-favorites/${encodeURIComponent(machineId)}`),

  /** Idempotent, and works for machines that no longer exist. */
  remove: (machineId: string) =>
    apiClient.delete<void>(`/admin/device-favorites/${encodeURIComponent(machineId)}`),
};
